export default __webpack_public_path__ + "static/media/learn.dbcba338.jpg";